// @flow
// react
import React, { useState, useEffect } from "react";
import {  Alert } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
// components
import CompactFileUploader from "./CompactFileUploader";
// Amplify
import { getCurrentUser } from "aws-amplify/auth";

let alert_string = "";
let alert_message = "";
let existing_files = [];

const CompactDocumentUpload = (props) => {
  console.log("props", props);
  const { t } = useTranslation(["components", "common"]);
  const [allFiles, setAllFiles] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [updateFile, setUpdateFile] = useState(false);

  let currentUser;
  getCurrentUser().then((user) => {
    currentUser = user;
  });

  useEffect(() => {
    if (props.documents && props.documents.length > 0) {
      setAllFiles(props.documents);
    }
  }, [props.documents]);

  useEffect(() => {
    if (showAlert === true) {
      setTimeout(function () {
        setShowAlert(false);
      }, 8000);
    }
  }, [showAlert]);

  const showAlertHandler = (files) => {
    files.forEach((file) => {
      existing_files.push(file.name);
    });
    alert_string = existing_files.join(", ");
    setShowAlert(true);
  };

  const hideAlertHandler = () => {
    existing_files = [];
    alert_string = "";
    setShowAlert(false);
  };

  const updateFilesHandler = (files) => {
    setAllFiles(files);
    // Auch das Entfernen muss beim Aufrufer ankommen, nicht nur das Hinzufuegen —
    // sonst laedt er beim Speichern eine geloeschte Datei trotzdem hoch.
    props.setTempDocuments([...files]);
    setUpdateFile(!updateFile);
  };

  return (
    <React.Fragment>
      {showAlert && (
        <Alert
          variant="danger"
          key={"file-alert"}
          onClose={hideAlertHandler}
          dismissible
        >
          {existing_files.length > 1 &&
            alert_message === "" &&
            `There are already documents in this ${props.documentsFor} with the names: ${alert_string}. If you want to upload the documents please rename them or delete the existing ones.
                `}
          {existing_files.length === 1 &&
            alert_message === "" &&
            `There is already a document in this ${props.documentsFor} with the name: ${alert_string}. If you want to upload the document, please rename it or delete the existing one.`}
          {alert_message !== "" && alert_message}
        </Alert>
      )}
      <p className="text-muted font-13 m-b-30">
        {t("Drag'n'Drop your Files here.")}
      </p>
      <CompactFileUploader
        onFileUpload={(files) => {
          const documents = files.map((file) => {
            if (file.id || file.file) {
              return file;
            } else {
              return {
                file: file,
                companyId: props.companyId,
                name: file.name,
                type: props.documentType,
                fileType: file.type,
                storageUrl: props.uploadPath,
                country: props.country,
                countries: props.countries,
                collectionName: props.collectionName,
              };
            }
          });
          props.setTempDocuments(documents);
        }}
        documents={allFiles}
        showAlertModal={showAlertHandler}
        hideAlertModal={hideAlertHandler}
        updateFilesHandler={updateFilesHandler}
        documentTypes={props.documentTypes}
        collectionName={props.collectionName}
        hideFiles={props.hideFiles}
      />
    </React.Fragment>
  );
};

export default CompactDocumentUpload;
